import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const EpicToaster = ({ theme, ...props }: ToasterProps) => {
  const { style, ...otherProps } = props
  const defaultToastContainerStyle = {
    width: '80%',
    maxWidth: '480px',
  }
  const defaultToastStyle = {
    width: '100%',
    maxWidth: '480px',
  }

  return (
    <Sonner
      richColors
      theme={theme}
      className="toaster group"
      pauseWhenPageIsHidden={true}
      toastOptions={{
        classNames: {
          icon: 'group-[.toaster]:self-start group-[.toaster]:mt-0.5',
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:mt-10',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
        style: { ...defaultToastStyle, ...style },
        duration: 6500,
      }}
      style={defaultToastContainerStyle}
      {...otherProps}
    />
  )
}

export { EpicToaster }
